import { getBaseUrl } from "./envConfig";

// ------------------------Create Url Confic--------------------------------

export const createUrlConfig = () => {
  const baseUrl = getBaseUrl();

  // ------------------------All Common url dynamic--------------------------------

  return {
    aiUrlConfig: baseUrl,
    loginUrlConfig: baseUrl,
    paymentUrlConfig: baseUrl,
    accountServiceUrlConfig: baseUrl,
    customerUrlConfig: baseUrl,
    consentUrlConfig: baseUrl,
    settingsUrlConfig: baseUrl,
    LFIUrlConfig: baseUrl,
    customerLocalUrlConfig: baseUrl,
    onboardConfig: baseUrl,
    consentConfig: baseUrl,
    consentloginConfig: baseUrl,
    consentLFIUrlConfig: baseUrl,
    rtpServiceUrlConfig: baseUrl,
    // bulkPaymentsPayrollServiceConfig: "http://192.168.1.115:8007/growx/api/v1/",
    bulkPaymentsPayrollServiceConfig: baseUrl,
    changeConfig: baseUrl,
    lfiUrlConfig: baseUrl,
    consentPollingConfig: baseUrl,
    NotifiUrlConfig: baseUrl,
  };
};
